import { supabase } from './supabase';

export const debugSubscriptionFetch = async () => {
  try {
    console.log('🔍 Starting subscription fetch debug...');
    
    // Check if user is authenticated
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError || !user) {
      console.error('❌ User not authenticated:', userError);
      return { success: false, error: 'User not authenticated' };
    }
    
    console.log('✅ User authenticated:', user.id);

    // Try to fetch subscriptions with different approaches
    console.log('🔍 Attempting direct subscription fetch...');
    
    // Method 1: Direct query
    try {
      const { data: subscriptions1, error: error1 } = await supabase
        .from('subscriptions')
        .select('*')
        .eq('user_id', user.id);
      
      console.log('📊 Method 1 - Direct query result:', { data: subscriptions1, error: error1 });
    } catch (err) {
      console.error('❌ Method 1 failed:', err);
    }

    // Method 2: Single query
    try {
      const { data: subscription2, error: error2 } = await supabase
        .from('subscriptions')
        .select('*')
        .eq('user_id', user.id)
        .single();
      
      console.log('📊 Method 2 - Single query result:', { data: subscription2, error: error2 });
    } catch (err) {
      console.error('❌ Method 2 failed:', err);
    }

    // Method 3: Check table existence
    try {
      const { data: tableInfo, error: tableError } = await supabase
        .from('subscriptions')
        .select('count(*)', { count: 'exact' });
      
      console.log('📊 Method 3 - Table info:', { data: tableInfo, error: tableError });
    } catch (err) {
      console.error('❌ Method 3 failed:', err);
    }

    // Method 4: Check with service role (if available)
    try {
      console.log('🔍 Checking RLS policies...');
      const { data: policies, error: policyError } = await supabase
        .rpc('get_table_policies', { table_name: 'subscriptions' });
      
      console.log('📊 RLS Policies:', { data: policies, error: policyError });
    } catch (err) {
      console.log('ℹ️ Could not check RLS policies (expected if function doesn\'t exist)');
    }

    return { success: true, message: 'Debug completed - check console for details' };

  } catch (error) {
    console.error('❌ Debug subscription fetch error:', error);
    return { success: false, error: error.message };
  }
};

// Make debug function globally available
if (typeof window !== 'undefined') {
  window.debugSubscriptionFetch = debugSubscriptionFetch;
  console.log('🔧 Subscription debug function loaded - run debugSubscriptionFetch() in console');
}

console.log('🚀 debugSubscriptions.js module loaded successfully');
